import { render } from "./VueDatePicker.vue?vue&type=template&id=1a6110e4"
import script from "./VueDatePicker.vue?vue&type=script&lang=js"
export * from "./VueDatePicker.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__